// Define a dictionary with all body parts and their properties
import Head from "../../assets/images/head.svg";
import Neck from "../../assets/images/neck.svg";
import Shoulders from "../../assets/images/shoulders.svg";
import LeftArm from "../../assets/images/left_arm.svg";
import RightArm from "../../assets/images/right_arm.svg";
import LeftLowerArm from "../../assets/images/left_lower_arm.svg";
import RightLowerArm from "../../assets/images/right_lower_arm.svg";
import LeftHand from "../../assets/images/left_hand.svg";
import RightHand from "../../assets/images/right_hand.svg";
import UpperBack from "../../assets/images/upper_back.svg";
import LowerBack from "../../assets/images/lower_back.svg";
import LeftLeg from "../../assets/images/left_leg.svg";
import RightLeg from "../../assets/images/right_leg.svg";
import LeftFoot from "../../assets/images/left_foot.svg";
import RightFoot from "../../assets/images/right_foot.svg";
const bodyPartCoordinates = {
  head: {
    x: 70,
    y: 15,
    width: 60,
    height: 80,
    href: Head,
    color: "rgba(255, 0, 0, 1)",
  },
  neck: {
    x: 50,
    y: 58,
    width: 100,
    height: 50,
    href: Neck,
    color: "rgba(255, 165, 0, 1)",
  },
  shoulders: {
    x: 40,
    y: 85,
    width: 120,
    height: 58,
    href: Shoulders,
    color: "rgba(255, 255, 0, 1)",
  },
  leftArm: {
    x: 22,
    y: 110,
    width: 60,
    height: 80,
    href: LeftArm,
    color: "rgba(0, 255, 0, 1)",
  },
  rightArm: {
    x: 120,
    y: 110,
    width: 60,
    height: 80,
    href: RightArm,
    color: "rgba(0, 255, 255, 1)",
  },
  leftLowerArm: {
    x: 35,
    y: 168,
    width: 30,
    height: 53,
    href: LeftLowerArm,
    color: "rgba(0, 0, 255, 1)",
  },
  rightLowerArm: {
    x: 135,
    y: 168,
    width: 30,
    height: 53,
    href: RightLowerArm,
    color: "rgba(128, 0, 128, 1)",
  },
  leftHand: {
    x: 30,
    y: 210,
    width: 40,
    height: 30,
    href: LeftHand,
    color: "rgba(255, 192, 203, 1)",
  },
  rightHand: {
    x: 130,
    y: 210,
    width: 40,
    height: 30,
    href: RightHand,
    color: "rgba(255, 182, 193, 1)",
  },
  upperBack: {
    x: 50,
    y: 86,
    width: 100,
    height: 105,
    href: UpperBack,
    color: "rgba(105, 105, 105, 1)",
  },
  lowerBack: {
    x: 65,
    y: 170,
    width: 70,
    height: 45,
    href: LowerBack,
    color: "rgba(169, 169, 169, 1)",
  },
  leftLeg: {
    x: 45,
    y: 190,
    width: 60,
    height: 150,
    href: LeftLeg,
    color: "rgba(128, 128, 0, 1)",
  },
  rightLeg: {
    x: 95,
    y: 190,
    width: 60,
    height: 150,
    href: RightLeg,
    color: "rgba(0, 128, 128, 1)",
  },
  leftFoot: {
    x: 60,
    y: 325,
    width: 25,
    height: 20,
    href: LeftFoot,
    color: "rgba(165, 42, 42, 1)",
  },
  rightFoot: {
    x: 115,
    y: 325,
    width: 25,
    height: 20,
    href: RightFoot,
    color: "rgba(210, 105, 30, 1)",
  },
};
export function getBodyPartCoordinates(name) {
  return bodyPartCoordinates[name] || {};
}
